class PageTitle {
    constructor(route = {
        path: "",
        name: "",
        params: {

        },
    }) {
        this.route = route;
        this.types = [
             {
                name: "madd",
                id: "madd_id"
            },
            {
              name: "opportunity",
              id: "opportunity_id"
            },
            {
                name: "intelligence",
                id: "intelligence_id"
            },
            {
                name: "sector",
                id: "sector_id"
            },
            {
                name: "member",
                id: "member_id"
            },
            {
                name: "event",
                id: "event_id"
            },
            {
                name: "activity",
                id: "activity_id"
            },
            {
                name: "activities",
                id: "activity_id"
            },
            {
                name: "insight",
                id: "insight_id"
            },
            {
                name: "user",
                id: "user_id"
            }
        ]
        this.init();
    }

    // Convert to title case, most titles come like Edit profile, we want this
    // to be Edit Profile
    toTitleCase(name) {
        let formattedTitleArray = name.split('');
        if(formattedTitleArray[0]) {
            formattedTitleArray[0] = formattedTitleArray[0].toUpperCase();
            name = formattedTitleArray.join("");
        }


        // getting all instances of ' ' followed by a letter.
        // The reasoning for this is to make the lower case titles e.g. view-opportunity
        // into title vase ie View Opportunity
         let wordCases = [...name.matchAll(/\s[a-z]/g)];
        // console.log("Word Cases: ", wordCases);
        if (wordCases) {
            wordCases.forEach((word) => {
                word = word[0];
                // the letter to capitalize will always be the second letter
                let charArray = word.split("");
                charArray[1] = charArray[1].toUpperCase();
                let capitalisedWord = charArray.join('');
                name = name.replace(word, capitalisedWord)
            })
        }

        return name;
    }

    dashToSpace(name) {
        return name.replaceAll("-", " ")
    }

    getValueFromParam(key) {
        return this.route.params[key] ? parseInt(this.route.params[key]) : null;
    }

    getStepFromParams() {
        return this.getValueFromParam("step");
    }

    formatViewOrPreviewTitle(name, id = null) {
        name = this.toTitleCase(this.dashToSpace(name));
        id = id ? id.toString() : "";
        return `${name} - ${id}`;
    }

    getIdFromParams(name) {
        for(let i = 0; i < this.types.length; i++) {
            if (name.includes(this.types[i].name)) {
                return this.getValueFromParam(this.types[i].id);
            }
        }

        return null;
    }

    formatTitle() {
        let title = "";
        const name = this.toTitleCase(this.dashToSpace(this.route.name));
        const id = this.getIdFromParams(this.route.name);
        const step = this.getStepFromParams();
        title = name;
        if (id) {
            title += ` - ${id}`;
        }

        if(step) {
            title += ` - Step ${step}`;
        }

        document.title = title + " - MAIS";
    }

    init() {
        this.formatTitle();
    }
}

export default PageTitle;
